export const siteInfo = {
  name: '打屁股视频大全',
  tagline: '汇聚全网最热门的打屁股视频内容',
  description: '打屁股视频精选合集，汇聚全网最热门的打屁股视频内容，包括亲子教育场景、影视经典片段、搞笑整蛊视频等，高清在线观看，每日更新，满足您对打屁股视频的多元化需求。',
  url: 'https://www.example.com',
  email: 'contact@example.com',
  phone: '400-123-4567',
  address: '中国北京市朝阳区xxx路xxx号',
  founded: '2024',
  socialLinks: {
    weibo: 'https://weibo.com/example',
    wechat: 'example_official',
  },
  stats: {
    totalVideos: 652,
    totalCategories: 6,
    totalViews: 15200000,
    dailyActiveUsers: 85000,
  },
};

export const aboutSections = [
  {
    id: 'brand-intro',
    title: '品牌介绍',
    content: '打屁股视频大全成立于2024年，是国内领先的垂直类视频合集分享平台。我们专注于收集、整理和分享全网最优质的打屁股相关视频内容，致力于为用户提供一站式的高清视频观看体验。\n\n我们的团队由资深内容运营和视频编辑组成，每天从海量网络内容中精心筛选出最有趣、最有价值的视频，按照科学的分类体系进行整理，让用户能够轻松找到自己感兴趣的内容。\n\n无论是亲子教育场景中的温馨互动，还是影视作品中的经典桥段，抑或是让人捧腹的搞笑整蛊，我们都能为您呈现最精彩的内容合集。我们相信，好的内容能够带给人欢乐和启发，这也是我们坚持不懈的动力。',
  },
  {
    id: 'reputation',
    title: '信誉口碑',
    content: '自成立以来，打屁股视频大全凭借优质的内容和良好的用户体验，赢得了广大用户的信赖和好评。我们的日均活跃用户超过8.5万人，累计视频播放量突破1520万次。\n\n我们始终坚持内容质量第一的原则，所有视频均经过人工审核，确保内容健康、积极、符合主流价值观。我们坚决反对任何形式的暴力内容，倡导正确的家庭教育理念，传播正能量。\n\n用户的口碑是我们最宝贵的财富。在各大社交平台上，我们的内容被广泛分享和讨论，许多用户表示本网站成为了他们日常休闲娱乐的首选平台。我们将继续努力，不辜负每一位用户的期待。',
  },
  {
    id: 'contact',
    title: '联系我们',
    content: '我们非常重视与用户的沟通和交流。如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们：\n\n📧 电子邮箱：contact@example.com\n📞 客服电话：400-123-4567（工作日 9:00-18:00）\n📍 公司地址：中国北京市朝阳区xxx路xxx号\n\n💬 社交媒体：\n- 新浪微博：@打屁股视频大全官方\n- 微信公众号：example_official\n\n📝 内容投稿与合作：\n如果您有优质内容想要推荐，或者希望进行商务合作，请发送邮件至合作邮箱，我们会在3个工作日内回复。',
  },
];